import KPIChooser from './KPIChooser';

export default KPIChooser;
